import React from "react";
import logo from "../logos/logo.png";
import { useTranslation } from 'react-i18next';
import engLogo from '../logos/eng-flag.png'
import frLogo from '../logos/fr-flag.png'

function Header(props) {

  const domain = window.location.hostname.split(".")[0] || "vendor";
  const isVendor = domain === "vendor";

    const { t, i18n } = useTranslation();
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

  return (
    <div
      style={{
        padding: 24,
        display: "flex",
        flexDirection: "column"
      }}
    >
        <div style={{display: "flex"}}>
        <img src={frLogo} alt="logo" style={{width: '30px', marginRight: '10px',cursor: 'grab'}} onClick={() => changeLanguage('fr')}/>
        <img src={engLogo} alt="logo" style={{width: '30px', cursor: 'grab'}} onClick={() => changeLanguage('en')}/>
        </div>

        <img
        src={ logo }
        alt="logo"
        style={{
          height: "277px",
          margin: "auto",
         // filter: 'invert(100%)',
          flex: 1,
          maxWidth: "200px",
            width: "200px",

        }}
      />
      <span
        style={{
          flex: 1,
          textAlign: "center",
          margin: "20px 0px",
          fontWeight: 700,
          fontSize: "2rem"
        }}
      >
        {isVendor ? t('title.vendor') : t('title.client') }
      </span>
      <span
        style={{
          flex: 1,
          margin: "20px 0px",
          fontWeight: 300,
          maxWidth: "700px!important",
          fontSize: "1.14rem"
        }}
      >
        {isVendor ? t('description.vendor') : t('description.client') }
      </span>
    </div>
  );
}

export default Header;
